







import Vue from 'vue';
import { IVisualizer } from '@types';

export default Vue.extend({
    props: {
        name: {
            type: String,
            required: true,
        },

        detail: {
            type: Boolean,
            required: false,
            default: false,
        },

        color: {
            type: String,
            required: false,
            default: '#ffffff',
        },

        useFade: {
            type: Boolean,
            required: false,
            default: false,
        },

        maxWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            unmuted: false,
            audioContext: null,
            audioSource: null,
            currentFile: null,
            currentRequest: null,
            barCount: 200,
            barWidth: 3,
            barGap: 1,

            playing: false,

            onLoad: undefined,
            onPlay: undefined,
            onStop: undefined,
        };
    },

    created() {
        this.$bus.$on('visualizer.play', this.busPlay);
        this.$bus.$on('visualizer.stop', this.busStop);
        this.$bus.$on('visualizer.stop.all', this.busStopAll);
    },

    destroyed() {
        this.stop();
        this.$bus.$off('visualizer.play', this.busPlay);
        this.$bus.$off('visualizer.stop', this.busStop);
        this.$bus.$off('visualizer.stop.all', this.busStopAll);
    },

    methods: {
        busPlay({ name, target, unmuteOnUserAction = true, onLoad, onPlay, onStop }: IVisualizer.IPlay) {
            if (name != this.name) {
                return;
            }
            if (onLoad) {
                this.onLoad = onLoad;
            }
            if (onPlay) {
                this.onPlay = onPlay;
            }
            if (onStop) {
                this.onStop = onStop;
            }

            this.play(target, unmuteOnUserAction);
        },

        busStop({ name }: IVisualizer.IStop) {
            if (name != this.name) {
                return;
            }
            this.stop();
        },

        busStopAll() {
            this.stop();
        },

        isAvailable() {
            return !!(window.AudioContext || window.webkitAudioContext);
        },

        unmuteOnUserAction() {
            if (this.unmuted) {
                return;
            }

            let audioContext = this.getAudioContext();
            let buffer = audioContext.createBuffer(1, 1, 22050);
            let source = audioContext.createBufferSource();
            source.buffer = buffer;
            source.connect(audioContext.destination);
            source[source.start ? 'start' : 'noteOn'](0);

            this.unmuted = true;
        },

        getAudioContext() {
            // return new (window.AudioContext || window.webkitAudioContext)();
            const AudioContext = window.AudioContext || window.webkitAudioContext;

            if (!this.audioContext) {
                this.audioContext = new AudioContext();
            }
            return this.audioContext;
        },

        play(target: any, unmuteOnUserAction: boolean) {
            const file = target.dataset.file;

            if (file == this.currentFile) {
                return true;
            }

            if (unmuteOnUserAction) {
                this.unmuted = true;
            } else {
                if (!this.unmuted) {
                    return false;
                }
            }

            this.stop();

            this.currentFile = file;

            this.loadAudio(file, target, (audioSource: any) => {
                this.onLoad && this.onLoad();

                this.audioSource = audioSource;

                audioSource.onended = () => this.stop();

                audioSource[audioSource.start ? 'start' : 'noteOn'](0);

                this.playing = true;
                this.onPlay && this.onPlay();

                this.startAnalyser(target);
            });

            return true;
        },

        stop() {
            if (this.audioSource) {
                this.audioSource.onended = undefined;
                this.audioSource[this.audioSource.stop ? 'stop' : 'noteOff'](0);
            }

            this.currentRequest = null;
            this.currentFile = null;
            this.audioSource = null;

            this.playing = false;
            this.onStop && this.onStop();
        },

        loadAudio(url: any, target: any, callback: any) {
            let self = this;
            let source = this.getAudioContext().createBufferSource();
            this.currentRequest = new XMLHttpRequest();
            this.currentRequest.open('GET', url, true);
            this.currentRequest.timeout = 10000; // break loading after 10s
            this.currentRequest.responseType = 'arraybuffer';

            this.currentRequest.ontimeout = function () {
                target.removeAttribute('loading');
                target.setAttribute('state', 'error');
            };

            this.currentRequest.onload = function () {
                if (this.status === 404) {
                    target.removeAttribute('loading');
                    target.setAttribute('state', 'error');
                    return;
                }
                if (this !== self.currentRequest) return;

                self.getAudioContext().decodeAudioData(this.response, function (buffer: any) {
                    source.buffer = buffer;
                    callback(source);
                });
            };
            this.currentRequest.send();
        },

        startAnalyser() {
            const analyser = this.getAudioContext().createAnalyser();
            analyser.fftSize = 512;

            this.$refs.canvas.width = 700;

            let ctx1 = this.$refs.canvas.getContext('2d');
            let requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame;

            let framesBeforeStop = 100;

            let frameLooper = () => {
                if (!this.$refs.canvas) {
                    return;
                }

                let bufferLength = analyser.frequencyBinCount;
                let fbc_array = new Uint8Array(bufferLength);
                analyser.getByteFrequencyData(fbc_array);

                ctx1.clearRect(0, 0, this.$refs.canvas.offsetWidth, this.$refs.canvas.offsetHeight);
                ctx1.fillStyle = this.color;

                for (let i = 0; i < bufferLength; i++) {
                    let bar_x = i * (this.barWidth + this.barGap);
                    let bar_height = -(fbc_array[i] / 2);
                    ctx1.fillRect(bar_x, this.$refs.canvas.height, this.barWidth, bar_height);
                }

                if (!this.playing) {
                    framesBeforeStop--;
                }

                if (framesBeforeStop == 0) {
                    return;
                }

                requestAnimationFrame(frameLooper);
            };

            this.audioSource.connect(analyser);
            analyser.connect(this.getAudioContext().destination);

            requestAnimationFrame(frameLooper);
        },
    },
});
